"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EDescriptionType = void 0;
let EDescriptionType = exports.EDescriptionType = /*#__PURE__*/function (EDescriptionType) {
  EDescriptionType["LIST"] = "list";
  EDescriptionType["PARAGRAPH"] = "paragraph";
  return EDescriptionType;
}({});